import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3724b495"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "showcase-panel pt-2"
};
var _hoisted_2 = {
  class: "browser-viewport p-4"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" I just arrived in Tokyo and the atmosphere here is stuning! I can't wait to try all the restaurants around me. ");

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});

var _hoisted_6 = /*#__PURE__*/_createTextVNode("For the people in my class that would like to meet me here, let me know!");

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" blue of tree is over ");

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" Comments ");

var _hoisted_9 = {
  class: "feed mt-3"
};
import { DateTime } from "luxon";
import ShowcaseUser from "@/components/ShowcaseUser.vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    posts: {
      default: function _default() {
        return [];
      }
    },
    clear: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;

    var getMessage = function getMessage(post) {
      return props.clear && post.message.clear ? post.message.clear : post.message.input;
    };

    return function (_ctx, _cache) {
      var _component_n_text = _resolveComponent("n-text");

      var _component_n_p = _resolveComponent("n-p");

      var _component_n_h4 = _resolveComponent("n-h4");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(ShowcaseUser, {
        name: "Adina Hansen",
        avatar: "/images/ui/people/people-01.jpg",
        "avatar-size": "large",
        time: _unref(DateTime).now().minus({
          days: 3
        }).toJSDate()
      }, null, 8, ["time"]), _createVNode(_component_n_p, null, {
        default: _withCtx(function () {
          return [_hoisted_3, _hoisted_4, _hoisted_5, __props.clear ? (_openBlock(), _createBlock(_component_n_text, {
            key: 0,
            strong: "",
            type: "info"
          }, {
            default: _withCtx(function () {
              return [_hoisted_6];
            }),
            _: 1
          })) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_hoisted_7], 64))];
        }),
        _: 1
      }), _createVNode(_component_n_h4, {
        class: "mt-4 mb-0"
      }, {
        default: _withCtx(function () {
          return [_hoisted_8];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.posts, function (post, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "post p-3 rounded",
          key: index
        }, [_createVNode(ShowcaseUser, {
          name: post.user.name,
          avatar: post.user.avatar,
          "avatar-size": "medium",
          time: post.time
        }, null, 8, ["name", "avatar", "time"]), _createVNode(_component_n_p, {
          class: "text m-0 p-0 pt-2"
        }, {
          default: _withCtx(function () {
            return [_createVNode(_Transition, {
              name: "list",
              mode: "out-in"
            }, {
              default: _withCtx(function () {
                return [(_openBlock(), _createBlock(_component_n_text, {
                  key: getMessage(post),
                  strong: __props.clear && post.message.clear,
                  type: __props.clear && post.message.clear ? 'info' : undefined
                }, {
                  default: _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(getMessage(post)), 1)];
                  }),
                  _: 2
                }, 1032, ["strong", "type"]))];
              }),
              _: 2
            }, 1024)];
          }),
          _: 2
        }, 1024)]);
      }), 128))])])]);
    };
  }
});